angular.module("accordionUpload.components", []).component("accordionUpload", {
	templateUrl: "ng/components/accordionUpload/accordionUpload.view.html",
	bindings: {
	  model: "<"
	  
	},
	controllerAs: "accordionUploadCtrl",
	controller: function () {
	  var self = this;    
  
	  self.$onInit = function () {
		
	  
  
	  
		
   
	  }
  
	  
	 
	}
  });